import { useMemo, useState } from "react";

import { SelectData } from "../../../models";

export const ADD_NEW_COMPANY_KEY = "CompanyPicker_addNew";

interface useCompanyPickerProps {
  data: SelectData;
  addNewCompanyLabel: string;
  onSelect: (collaboratorUuid: string) => void;
  onAddNewCompany: (currentSearchTerm: string) => void;
}

interface useCompanyPickerReturnData {
  optionsData: SelectData;
  handleChange: (value: string) => void;
  handleSelect: (key: string) => void;
}

export const useCompanyPicker = ({
  data,
  addNewCompanyLabel,
  onSelect,
  onAddNewCompany,
}: useCompanyPickerProps): useCompanyPickerReturnData => {
  const [searchTerm, setSearchTerm] = useState("");

  // Memoised so the array identity is stable — a new array each render would retrigger
  // Autocomplete's data effect and reset the filtered options.
  const optionsData = useMemo(
    () => [...data, { key: ADD_NEW_COMPANY_KEY, value: addNewCompanyLabel }],
    [data, addNewCompanyLabel]
  );

  const handleChange = (value: string): void => {
    setSearchTerm(value);
  };

  const handleSelect = (key: string): void => {
    if (key === ADD_NEW_COMPANY_KEY) {
      onAddNewCompany(searchTerm);
      // Handed over to the add-company form; keeping it would reseed that form on a later add with no typing.
      setSearchTerm("");
      return;
    }

    onSelect(key);
  };

  return { optionsData, handleChange, handleSelect };
};
